import { Controller } from 'react-hook-form';
import { Form, InputNumber } from 'antd';
import type { FieldValues } from 'react-hook-form';
import type { InputNumberProps } from 'antd';
import type { RHFBaseProps, CommonChrome } from './types';
import { DEFAULT_FORM_LAYOUT } from './constants';

export type ControlledNumberInputProps<TFieldValues extends FieldValues = FieldValues> =
  RHFBaseProps<TFieldValues> &
    CommonChrome &
    Omit<InputNumberProps, 'value' | 'onChange'>;

export function ControlledNumberInput<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  required,
  disabled,
  help,
  layout,
  fieldClassName,
  ...rest
}: ControlledNumberInputProps<TFieldValues>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <Form.Item
          label={label}
          required={required}
          validateStatus={fieldState.error ? 'error' : undefined}
          help={fieldState.error?.message ?? help}
          layout={layout ?? DEFAULT_FORM_LAYOUT}
          className={fieldClassName}
        >
          <InputNumber
            {...rest}
            value={value ?? undefined}
            onChange={val => onChange(val ?? null)}
            disabled={disabled}
            style={{ width: rest.style?.width ?? '100%' }}
          />
        </Form.Item>
      )}
    />
  );
}
